(function() { window.GUID_adb527ef_7bb8_4ff7_85b6_bb10c39b74d6 = { getGuid: function() { return "adb527ef-7bb8-4ff7-85b6-bb10c39b74d6"; } }; })();
var CS;
(function (CS) {
    let Controls;
    (function (Controls) {
        function GetInstance(constructor, selector, byPassThrowExceptionOnNoInstance = false) {
            //selector peut etre une string mais aussi, un element jquery direct, donc, doit etre any | no -> string | JQuery | HTMLElement
            let exist = $(selector).data("instances");
            if (exist) {
                let end = exist.length;
                for (var i = 0; i < end; i++) {
                    //let current = exist[i] as TControl; => this dont work, javascript compiled to : var current = exist[i];
                    if (exist[i] instanceof constructor) {
                        return exist[i];
                    }
                }
            }
            if (!byPassThrowExceptionOnNoInstance) {
                //throw new Error(`Cant get an instance of "${Types.GetName(constructor)}" from the selector "${selector.toString()}"`);
                console.error(`Cant get an instance of "${CS.Types.GetName(constructor)}" from the selector "${selector.toString()}"`);
            }
            return null;
        }
        Controls.GetInstance = GetInstance;
        function IsInstanceExist(constructor, selector) {
            let exist = $(selector).data("instances");
            if (exist) {
                let end = exist.length;
                for (var i = 0; i < end; i++) {
                    //let current = exist[i] as TControl; => this dont work, javascript compiled to : var current = exist[i];
                    if (exist[i] instanceof constructor) {
                        return [true, exist[i]];
                    }
                }
            }
            return [false, null];
        }
        Controls.IsInstanceExist = IsInstanceExist;
        class PrimitiveControlBase extends CS.CSInstanceBase {
            constructor() {
                super();
            }
            ControlType(instance) {
                if (!instance)
                    instance = this;
                return CS.Types.GetName(instance);
            }
            Dispose() {
                if (!this.disposed) {
                    this.OnDispose();
                    this.disposed = true;
                    CS.Helper.logWithColor(this.ControlId, "#D3D369", "control disposed");
                }
            }
            getId() {
                var id = this.ControlId;
                if (id == null || id == undefined || id == "") {
                    if (this.$Control != null &&
                        this.$Control.length > 0 &&
                        this.$Control.is("[id]")) {
                        id = this.$Control.attr("id");
                    }
                    else {
                        id = this.$Control.data("id");
                    }
                }
                if (id == null || id == undefined || id == "")
                    id = this.UniqueInstanceId;
                return id;
            }
            get UniqueNamespace() {
                return `${this.ControlType()}-${this.getId()}`;
            }
        }
        Controls.PrimitiveControlBase = PrimitiveControlBase;
        class ControlBaseParam {
            constructor(delayIsInstantiated, dontRaiseLoadedEvent, $element) {
                this.delayIsInstantiated = delayIsInstantiated;
                this.dontRaiseLoadedEvent = dontRaiseLoadedEvent;
                this.$element = $element;
            }
        }
        Controls.ControlBaseParam = ControlBaseParam;
        class ControlBase extends PrimitiveControlBase {
            constructor(...params) {
                super();
                let me = this;
                for (var i = 0; i < params.length; i++) {
                    if (params[i] instanceof ControlBaseParam) {
                        this.baseParam = params[i];
                        break;
                    }
                }
                if (!this.baseParam)
                    this.baseParam = new ControlBaseParam(false, false, null);
                this.OnControlInstantiation(params);
                CS.Helper.logWithColor(me.ControlId, "#83A5FF", "control instantiated");
                if (this.Singletone) {
                    return;
                }
                CS.DOM.AssignInstanceToJQueryElement(me, me.$Control);
                //Enleve le document ready pour les child accordion
                $(document).ready(function () {
                    me.OnBindEvents();
                    if (!me.baseParam.dontRaiseLoadedEvent) {
                        me.OnControlRendered();
                    }
                });
                CS.DOM.AddDisposableClass(me.$Control);
            }
            get isDebug() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false;
            }
            static get isStaticDebug() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false;
            }
            Is(selector) {
                let sel = selector instanceof Controls.ControlBase;
                if (sel &&
                    selector.UniqueNamespace === this.UniqueNamespace) {
                    return true;
                }
                else if (this.$Control.is(selector)) {
                    return true;
                }
                return false;
            }
            Trigger(event, data) {
                if (this.$Control) {
                    this.$Control.trigger(event, data);
                }
            }
            OnControlRendered() {
                this.Trigger(ControlBase.BaseEventNames.ControlBaseLoaded, { data: this, jqueryEventObject: null });
            }
            Log(...args) {
                CS.Helper.log(this.constructor.name, ...args);
            }
            static staticLog(...args) {
                CS.Helper.log(this.name, ...args);
            }
        }
        Controls.ControlBase = ControlBase;
        (function (ControlBase) {
            class BaseEvents {
                /**
                 * Raised then the control is rendered (When JQuery.documentReddy is raised)
                 * @param param
                 */
                static ControlBaseLoaded(constructor, param) {
                    Controls.RegisterEvent(constructor, BaseEventNames.ControlBaseLoaded, param);
                }
            }
            ControlBase.BaseEvents = BaseEvents;
            class BaseEventNames {
            }
            BaseEventNames.ControlBaseLoaded = "controlbase-loaded";
            ControlBase.BaseEventNames = BaseEventNames;
            class Helpers {
            }
            ControlBase.Helpers = Helpers;
        })(ControlBase = Controls.ControlBase || (Controls.ControlBase = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=control-base.pre.js.map
